import Vue from 'vue';

import App from './component/App.vue';

new Vue({
    el: '#demo',
    render: h => h(App)
}).$mount('#demo');



// WEBPACK FOOTER //
// ./src/js/app/demo/index.js